import Vue from 'vue'
import Vuex from 'vuex'
import userInfo from './modules/userInfo'
import keepAlive from './modules/keepAlive'

Vue.use(Vuex)

export default new Vuex.Store({
	// strict: process.env.NODE_ENV !== 'production',
	// 模块
	modules: {
		userInfo,
		keepAlive
	}
})


// WEBPACK FOOTER //
// ./src/store/index.js